<ng-container *ngIf="customStyle" >
    <mat-accordion>
        <mat-expansion-panel [expanded]="false" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Description
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="description-style" >
            <div class="text" [innerText]="customStyle.description" > </div>
            <div class="image">
                <img [src]="environment.backend+customStyle.icon">
              </div>
        </div>
        </mat-expansion-panel>
    </mat-accordion>
    
</ng-container>

<div fxLayout="column" class="polygon-simple-form" >

  <app-color-picker [colorOutputFormat]="'hex'" [colorLabel]=" 'admin.symbology.polygon.fillColor' | translate " [colorForm]="form.get('fillColor')" ></app-color-picker>

  <mat-form-field appearance="legacy" style="width: 100%;" >
    <mat-label> {{'admin.symbology.polygon.strokeWidth' | translate }} </mat-label>
    <input matInput type="number" [formControl]="form.get('strokeWidth')" name="strokeWidth" >
  </mat-form-field>

  <app-color-picker [colorOutputFormat]="'hex'" [colorLabel]=" 'admin.symbology.polygon.strokeColor' | translate " [colorForm]="form.get('strokeColor')" ></app-color-picker>


</div>